<script>
	import PrimaryNav from '@/components/PrimaryNav'

	export default {
		name: 'appHeader',
		components: { PrimaryNav },
		computed: {
			showOverlayNav () {
				return this.$store.state.app.overlayNavActive
			}
		},
		render () {
			let classes = "header"

			if(this.$route.path === '/') {
				classes += " is-home"
			}

			return (
				<div class="header" class={classes}>
					{this.$store.state.app.embedMode ? (
						<img src={require('./img/logo-ss.svg')} class="logo" />
					) : (
						<router-link to={{ name: 'homepage' }}>
							<img src={require('./img/logo.svg')} class="logo" />
						</router-link>
					)}
					{!this.showOverlayNav && !this.$store.state.app.embedMode && (
						<PrimaryNav />
					)}
				</div>
			)
		}
	}
</script>

<style lang="scss" scoped>
	@import "responsive-font";
	.header {
		@include responsive-font(10);
		display:flex; justify-content:space-between; align-items:center; position:absolute; top:0; right:0; left:0; z-index:100; padding:1.5em 3em;
	}
	.logo {
		display:block; width:17em; height:auto;
	}
	.is-home {
		margin-top: 40px;
	}
</style>



// WEBPACK FOOTER //
// src/components/AppHeader/index.vue